import {
  Avatar,
  Box,
  Button,
  SelectChangeEvent,
  Stack,
  Typography,
} from '@mui/material';
import { ControlledSelectCheckmark } from 'Components/ControlledSelectCheckmark';
import { TherapySuppliersContext } from 'Context/SuppliersContext/TherapySuppliersContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { PurpleX } from 'Images';
import { ITherapySuppliers } from 'Interfaces/therapySuppliers';
import { ReactNode, useContext } from 'react';
import { useFormContext } from 'react-hook-form';

const Expertise = () => {
  const { expertise } = useContext(TherapySuppliersContext);

  const { setValue, watch } = useFormContext<ITherapySuppliers>();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Suppliers
  ).therapySearchForm;

  return !expertise.resources ? (
    <></>
  ) : (
    <Stack
      gap='20px'
      sx={{
        '.MuiSvgIcon-root > path': {
          strokeWidth: '0.833333',
          stroke: '#A020FF',
        },
      }}
    >
      <Typography variant='body2'>{dictionary.subSpecialization}</Typography>
      <Box
        position={'relative'}
        sx={{
          '.MuiSelect-icon': {
            visibility: watch('expertise')?.length > 0 ? 'hidden' : 'visible',
          },
        }}
      >
        <ControlledSelectCheckmark
          placeholder={dictionary.subSpecializationPlaceholder}
          options={expertise.resources.map((resource) => resource.content)}
          selected={(watch('expertise') || [])
            .map(
              (subSpecial) =>
                (expertise.resources || []).find(
                  (s) => s.resourceId === subSpecial
                )?.content || ''
            )
            .filter((subSpecial) => subSpecial !== '')}
          onChange={(event: SelectChangeEvent<string[]>, child: ReactNode) => {
            setValue(
              'expertise',
              (
                (typeof event.target.value === 'string'
                  ? [event.target.value]
                  : event.target.value) || []
              )
                .map(
                  (subSpecial) =>
                    (expertise.resources || []).find(
                      (s) => s.content === subSpecial
                    )?.resourceId || -1
                )
                .filter((subSpecial) => subSpecial !== -1)
            );
          }}
          size={'small'}
          maxHeight={273}
          ariaLabel={dictionary.subSpecialization}
          ariaDescription={dictionary.subSpecializationDescription}
        />
        {watch('expertise')?.length > 0 && (
          <Button
            onClick={() => {
              setValue('expertise', []);
            }}
            sx={{
              height: '40px',
              width: '40px',
              minWidth: '40px',
              position: 'absolute',
              top: '0px',
              right: '4px',
              backgroundColor: 'white',
              zIndex: 1,
            }}
          >
            <Avatar
              alt={dictionary.resetSubSpecialization}
              src={PurpleX}
              sx={{ width: '20px', height: '20px' }}
            />
          </Button>
        )}
      </Box>
    </Stack>
  );
};

export default Expertise;
